<template>
  <el-col class="assembly_box ">
    <div class="assembly_title">应急队伍

      <img src="@/assets/img/drillCenter/line.png" style="width: 78px;height: auto;" alt="">

    </div>
    <div class="assembly_content_box">
      <div class="assembly_list" v-for="(item, index) in userInfo" :key="index">

        <div class="emergency_team_left">       
           <img src="@/assets/img/drillCenter/dingwei.png" style="width: 13px;height: 13px;margin-right: 5px;" alt="">
 {{ item.userName }}</div>
        <!-- <div class="line"></div> -->
        <div class="emergency_team_right">队伍中</div>
      </div>
    </div>
  </el-col>
</template>
<script>
export default {
  name: "drillCenterTeam",
  components: {},
  props: {
    userInfo: {
      type: Array,
      default: () => {
        return [];
      }
    }
  },
  data() {
    return {};
  },
  created() {},
  mounted() {},
  computed: {},
  watch: {},
  methods: {},
  destroyed() {}
};
</script>
<style lang="scss" scoped>
.assembly_box {
  float: left;
  height: 100%;
  border: 2px solid #191919;
  padding:  2rem 0; 
  border-left: none;
  border-right: none;
  overflow: scroll;
}
.assembly_content_box{
  height:100%;overflow: scroll;
}
.assembly_list {
  width: 100%;
  font-size:14px;
  display: flex;
  padding: 1rem;
  align-items: center;
  color: #0f0505;
  opacity: 0.9;
  justify-content: space-between;
  // color: #21bf25;
}
.emergency_team_left{
  width: 160px;
}
.line{
  border: .5px  dashed #96B6CF;
  
  width: 220px;
  margin: 0 5px;
  height: 1px;
}
.emergency_team_right{
  color: #21bf25;
}

</style>
